<template>
  <div
    id="BookingConfirmed"
    class="d-flex flex-column align-items-center content-container container-width brand-text text-center animate__animated animate__fadeIn booking-confirm-container border-brand-tertiary"
  >
    <i class="fa fa-circle-check confirm-check"></i>
    <h3 class="dmh-start-title brand-text p-0">
      Booking confirmed!
    </h3>
    <div class="brand-text mb-5">
      <div class="pb-4">
        You should soon receive an email confirming your booking, followed by a
        reminder email {{ reminderWindow }} hours before your appointment to your registered email
        address.
      </div>
      <div>
        To attend or cancel your session, go to the booking area on the 'My
        Health' page.
      </div>
    </div>
    <div v-if="isImportantNoteShown" class="important-note">
      <div class="important-header">
        <p class="important-title">
          <i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
          Important Note
        </p>
        <button @click="hideImportantNote" class="close-button">
          <i
            class="fa fa-times"
            aria-hidden="true"
          ></i>
        </button>
      </div>
      <p class="brand-text">
        For both audio appointments and video appointments, you will need to
        return to the app to join your session at the scheduled time.
      </p>
      <p class="brand-text mb-0">
        Ensure you log in a few minutes before your appointment to avoid missing
        your session.
      </p>
    </div>
    <div class="w-100">
      <b-button
        variant="cta"
        size="lg"
        id="return-to-home-button"
        class="py-4 px-5 w-100"
        squared
        @click="$router.push('/')"
        >Return to 'My Health'</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingConfirmed",
  props: {
    is24HoursReminder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isImportantNoteShown: true
    };
  },
  methods: {
    hideImportantNote() {
      this.isImportantNoteShown = false;
    }
  },
  computed: {
    reminderWindow() {
      return this.is24HoursReminder ? "24" : "48"
    }
  }
};
</script>

<style lang="less">
#BookingConfirmed {
  .confirm-check {
    font-size: 10rem;
    color: #02b57c;
    margin-bottom: 32px;
  }
  
  .dmh-start-title {
    text-align: center;
    font-size: 2.2rem;
    letter-spacing: 0;
    font-family: "PlusJakartaSansBold";
    padding: 0;
    margin-bottom: 32px;
  }
  
  .important-note {
    text-align: left;
    border-radius: 20px;
    background-color: #ffef99;
    padding: 24px;
    margin-bottom: 32px;
  }
  
  .important-title {
    color: #594b00 !important;
    font-family: "PlusJakartaSansBold";
    margin: 0;
  }
  
  .important-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  
    .fa-times {
      cursor: pointer;
      font-size: 2rem;
    }
  }

  .close-button {
    border: none;
    background-color: unset;
  }
}
</style>
